import { render, staticRenderFns } from "./PurchaseGalleryItemFiles.vue?vue&type=template&id=99f7dfb6&scoped=true&"
import script from "./PurchaseGalleryItemFiles.vue?vue&type=script&lang=ts&"
export * from "./PurchaseGalleryItemFiles.vue?vue&type=script&lang=ts&"
import style0 from "./PurchaseGalleryItemFiles.vue?vue&type=style&index=0&id=99f7dfb6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99f7dfb6",
  null
  
)

export default component.exports